<script>
	import { store } from "../store.js";
	import { getPosts } from "../getPosts.js";
	import Grid from "../assets/icons/Grid.svelte";
	import List from "../assets/icons/List.svelte";
	import Map from "../assets/icons/Map.svelte";

	async function switchMode(mode) {
		$store.options[$$props.id].filtres.mode = mode;
		console.log(mode);

		// console.log($store.options[$$props.id].filtresParDefaut.type_contenus);

		if (
			mode === "list" &&
			$store.options[$$props.id].filtresParDefaut.type_contenus.includes("post")
		) {
			$store.options[$$props.id].filtres.type_contenus = "evenement,formation";
		} else {
			$store.options[$$props.id].filtres.type_contenus =
				$store.options[$$props.id].filtresParDefaut.type_contenus;
		}

		// console.log($store.options[$$props.id]);

		let params = new URLSearchParams(
			$store.options[$$props.id].filtres
		).toString();

		let myPosts = await getPosts(params);
		$store.posts[$$props.id] = myPosts;
		$store.options[$$props.id].found_posts = myPosts.found_posts;
		$store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
		$store.options[$$props.id].loading = false;
	}
	let unique_id = Math.floor(Math.random() * 100);
</script>

<div class="cs_mode">
	<button on:click={() => switchMode("grid")}
		><Grid id={$$props.id} data-unique_id={"grid_" + unique_id} /></button
	>

	<button on:click={() => switchMode("map")}
		><Map id={$$props.id} data-unique_id={"map_" + unique_id} /></button
	>
</div>
